import { fetchWithTimeout } from './http';

const BASE = import.meta.env.VITE_API_BASE_URL ?? '';

export type NegativeFeedbackCategory =
  | 'inaccurate'
  | 'missing_sources'
  | 'did_not_answer'
  | 'unclear'
  | 'too_verbose'
  | 'too_short'
  | 'other';

export const NEGATIVE_FEEDBACK_CATEGORIES: { value: NegativeFeedbackCategory; label: string }[] = [
  { value: 'inaccurate', label: 'Inaccurate information' },
  { value: 'missing_sources', label: 'Missing sources / citations' },
  { value: 'did_not_answer', label: 'Did not answer the question' },
  { value: 'unclear', label: 'Confusing or unclear' },
  { value: 'too_verbose', label: 'Too verbose' },
  { value: 'too_short', label: 'Too short' },
  { value: 'other', label: 'Other' },
];

export async function submitFeedback(
  traceId: string,
  sessionId: string,
  score: 1 | -1,
  comment?: string,
  categories: NegativeFeedbackCategory[] = [],
): Promise<void> {
  const res = await fetchWithTimeout(`${BASE}/api/v1/feedback`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ trace_id: traceId, session_id: sessionId, score, comment, categories }),
  });
  if (!res.ok) {
    throw new Error(`Feedback request failed: HTTP ${res.status}`);
  }
}
